// extracted by mini-css-extract-plugin
export var fadeIn = "_cf-1";
export var modalContent = "_cf-3";
export var overlay = "_cf-0";
export var popoverContent = "_cf-2";
export var results = "_cf-5";
export var searchInputWrapper = "_cf-4";